import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const MaxWidthContainerWidgetV2: WidgetRegistryEntry = {
  name: "MaxWidthContainerV2",
  configuration: () => import("./configuration").then((m) => m.MaxWidthContainerWidgetV2Configuration),
  component: () => import("./max-width-container-widget-v2.component").then((m) => m.MaxWidthContainerWidgetV2Component)
};
